(function () {
  if (window.__shippingTimeInitialized) {
    return;
  }
  window.__shippingTimeInitialized = true;

  function updateDeliveryTime(variantId) {
    // get all created variant contents
    const elements = document.querySelectorAll('.shipping-time-display [data-shipping-variant-id]');
    let first = true;
    elements.forEach((el) => {
      let display = 'none';
      // either show the one for the current variantId OR the first one, if no variantId is given (first page load)
      if ((variantId && el.getAttribute('data-shipping-variant-id') == variantId) || (!variantId && first)) {
        display = 'inline-block';
      }

      first = false;
      el.style.display = display;
    });
  }

  // keep the "Lieferzeit" line item property input of the product form in sync with the selected variant
  function updateLineItemProperty(form, variant) {
    const input = form.querySelector('input[data-shipping-time-property]');
    const mapScript = form.querySelector('script[data-shipping-time-map]');

    if (!input || !mapScript) {
      return;
    }

    try {
      const map = JSON.parse(mapScript.textContent);

      if (Object.prototype.hasOwnProperty.call(map, String(variant.id))) {
        input.value = map[String(variant.id)];
      }
    } catch (error) {
      // Invalid JSON map; keep the current value
    }
  }

  // "variant:change" is dispatched on the product form and bubbles up to the document
  document.addEventListener('variant:change', function (event) {
    const variant = event.detail && event.detail.variant;

    updateDeliveryTime(variant ? variant.id : null);

    if (variant && event.target instanceof Element) {
      updateLineItemProperty(event.target, variant);
    }
  });

  window.updateDeliveryTime = updateDeliveryTime;
})();
